/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAPIError from '../../../hooks/useAPIError';
import { useAuthStore } from '../../../store/AuthContext';
import TarjetaService from '../../../services/TarjetaService';
import clubTarjeta from '../../../assets/images/club-tarjeta.png';
import SolicitarInformacionTPEC from '../commons/SolicitarInformacionTPEC';
import TarjetaTemporalSolicitarTarjeta from '../commons/TarjetaTemporalSolicitarTarjeta';
import SolicitarTarjetaOro from '../commons/SolicitarTarjetaOro';
import { BackMappings } from '../../../utils/BackMappings';
import { StorageHelper } from '../../../utils/StorageHelper';
import useSessionChecking from '../../../hooks/useSessionChecking';
import { CryptoUtil } from '../../../utils/CryptoUtil';

const TitularEroski: FC = () => {
  const [goOn, setGoOn] = useState<boolean>(false);
  StorageHelper.setOrigin(BackMappings.TARJETA);
  useSessionChecking(BackMappings.TARJETA, setGoOn, goOn);

  const { t } = useTranslation();
  const dataUser = useAuthStore();
  const { addError, addErrorBack } = useAPIError();
  const [load, setLoad] = useState<boolean>(true);
  const [cardNumberLong, setCardNumberLong] = useState<string>();
  const [firstCharge, setFirstCharge] = useState(true);

  const getCardNumber = () => {
    TarjetaService.getTarjeta()
      .then((response) => {
        if (response.data.error) {
          if (
            firstCharge &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          setLoad(false);
          addErrorBack(response.data);
        } else {
          setCardNumberLong(
            CryptoUtil.decryptAes(response.data.pojo.cardNumberLong),
          );
        }
        setFirstCharge(false);
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };
  useEffect(() => {
    if (dataUser.user.token !== '') {
      getCardNumber();
      setLoad(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (dataUser.user.token !== '') {
      getCardNumber();
    }
  });

  if (goOn) {
    return (
      <>
        {(() => {
          if (load) {
            return (
              <>
                {' '}
                <section className="section header-tarjetas tarjetas">
                  <div className="container">
                    <div className="header-tarjetas__content">
                      <h1 className="header-tarjetas__title">
                        {t('tarjetas.tarjeta-socio.title')}
                      </h1>
                      <p>
                        {t('tarjetas.tarjeta-socio.partner-card')}&nbsp;
                        <strong>{cardNumberLong}</strong>
                      </p>
                    </div>
                  </div>
                </section>
                <section className="o-section--giant__top u-padding-bottom-hero section--background">
                  <div className="container-inner">
                    <div className="img-tarjeta">
                      <img src={clubTarjeta} alt="Tarjeta Eroski Club" />
                    </div>

                    <div className="tarjeta__content">
                      <h2 className="bloque-datos__title">
                        <span className="divider__square brand-color" />
                        <span className="u-margin-right">
                          {t('tarjetas.tarjeta-socio.eroski-club')}
                        </span>
                      </h2>
                      <TarjetaTemporalSolicitarTarjeta />
                    </div>
                  </div>
                </section>
                {(() => {
                  if (
                    !dataUser.user.isGibraltar &&
                    !dataUser.user.isEmpresa &&
                    !StorageHelper.isEcommerceBot()
                  ) {
                    return (
                      <section className="o-section--superhero tarjetas">
                        <div className="container">
                          <h2 className="titulo-pagina u-text-brand u-text-center">
                            {t('tarjetas.tarjeta-socio.save-more')}
                          </h2>
                          <SolicitarTarjetaOro />

                          <SolicitarInformacionTPEC />
                        </div>
                      </section>
                    );
                  }
                  return false;
                })()}
              </>
            );
          }
          return false;
        })()}
      </>
    );
  }
  return <></>;
};

export default TitularEroski;
